export default __webpack_public_path__ + "static/media/TXUI_Ramp_Corner_8x4.256.7a22b4af.png";